import { createRolesHooks } from '@gasbi/shared/common/features/roles';

import {
  organizationsApi,
  useGetCachedRoleByIdSelector as useGetCachedOrgRoleByIdSelector,
} from '../organizations/organizationsApi';
import { isRootRole } from './utils';

// BMS has no head office view (PO, 2026-10-26: the head office is Distribution Admin's «Адміністрація»), so the
// head office side of the hooks is the organization roles too.
export const {
  useGetSystemRolesQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useSaveRoleMutation,
  useAssignRoleMutation,
  useSuspendRoleMutation,
  useGetCachedRoleByIdSelector,
} = createRolesHooks(
  organizationsApi,
  organizationsApi,
  useGetCachedOrgRoleByIdSelector,
  useGetCachedOrgRoleByIdSelector,
  isRootRole,
);
